import { SaveOfferRequestDto } from '@wwt/entities/api/search-response'
import { Offer } from '@wwt/entities/search-response'

export const offerToOfferRequest = (offer: Offer): SaveOfferRequestDto => {
	const { IDs, roomDynamic, hotelDynamic } = offer

	return {
		metaData: IDs,
		offerDynamicData: {
			roomDynamicData: roomDynamic,
			hotelDynamicData: hotelDynamic
		}
	}
}
